const recommendationActions = {
    ADD: 'add',
    REMOVE: 'remove',
};

export default recommendationActions;
